/* eslint-disable no-console */
import React, { useEffect } from "react";
import { Redirect, useLocation } from "react-router";
import { PRACTICESTATES } from "../../model/practice";

import { usePractice } from "../../viewmodel/hooks/getPractice";
import PlayQuestionPractice from "./PlayQuestionPractice";

import { useProfile } from "../../viewmodel/hooks/getProfile";
import { getUserInfo } from "../../viewmodel/providers/userInfo";
import api from "../../utils/api";
import apiRoutes from "../../utils/apiRoutes.json";
import routes from "../../utils/routes.json";
import { UserContext } from "../../viewmodel/providers/user-context";


type locationState = {
    userId: string,
    categoryIds: string[],
}

const NUM_QUESTIONS = 10;

export default function Practice(): JSX.Element {

    const [state, setPracticeState, setPractice, incrementQuestionNumber, setQuestions, incrementQuestionInfo] = usePractice();

    const location: locationState = useLocation<locationState>().state;

    const userId: string = React.useContext(UserContext).userId;

    const [user, setProfileUser] = useProfile();
    useEffect(() => {
        if (location !== undefined)
            getUserInfo(userId, setProfileUser);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId]);


    // const [questions, setObj] = useState();
    useEffect(() => {
        api.post(
            apiRoutes.practice,
            {
                // eslint-disable-next-line camelcase
                num_questions: NUM_QUESTIONS,
                categories: location.categoryIds,
            },
        ).then((response) => {
            setQuestions(response.data["questions"]);
            setPracticeState(PRACTICESTATES.RESTART_QUESTION);
        },
        ).catch((err) => {
            console.log(err);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    if (!location)
        return <Redirect to={routes.menu} />;

    const chooseOption = (n: number) => {
        console.log(n);
        const opt = String.fromCharCode(97 + n);

        incrementQuestionInfo(state.questions[state.questionNumber - 1].resposta === opt, performance.now() - state.startTime);

        setTimeout(() => {
            setPracticeState((state.questionNumber < state.questions.length) ? PRACTICESTATES.RESTART_QUESTION : PRACTICESTATES.ENDGAME);
        }, 3000);
        setPracticeState(PRACTICESTATES.SHOW_QUESTION);
    };


    let component =
        <PlayQuestionPractice
            user={user.user}
            key={state.questionNumber}
            question={state.question} options={state.options} duration={state.duration} questionNumber={state.questionNumber}
        />;

    switch (state.state) {
        case PRACTICESTATES.START_GAME:

            break;
        case PRACTICESTATES.RESTART_QUESTION:
            {
                console.log(state.questions);
                const question = state.questions[state.questionNumber];
                setPractice(question.pergunta, [question.hipotese_a, question.hipotese_b, question.hipotese_c, question.hipotese_d], 20);
                incrementQuestionNumber();
                setPracticeState(PRACTICESTATES.QUESTIONS);
            }
            break;
        case PRACTICESTATES.SHOW_QUESTION:
            {
                component =
                    <PlayQuestionPractice
                        user={user.user}
                        key={state.questionNumber}
                        question={state.question} options={state.options} duration={state.duration} questionNumber={state.questionNumber}
                        chooseOption={chooseOption}
                        correctOption={state.questions[state.questionNumber - 1].resposta}
                    />;
            }
            break;
        case PRACTICESTATES.QUESTIONS:
            component =
                <PlayQuestionPractice
                    user={user.user}
                    key={state.questionNumber}
                    question={state.question} options={state.options} duration={state.duration} questionNumber={state.questionNumber}
                    chooseOption={chooseOption}
                />;
            break;
        case PRACTICESTATES.ENDGAME:
            return <Redirect
                to={{
                    pathname: routes.practiceResults, state: {
                        user: user.user,
                        correctAnswers: state.correctAnswers,
                        timePerQuestion: Math.round(state.timeToAnswer * 100 / NUM_QUESTIONS) / 100000,
                        categoryIds: location.categoryIds,
                    },
                }} />;
        default:
            break;
    }


    return (component);
}
